const constants = require('@/util/constants')
require('./config')

/**
 * 获取智能问答
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getRobotAnswers (categoryId, page, size, successcb, failedcb) {
  axios.get('/api/answer/get', {
    params: {
      'categoryId': categoryId,
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 创建智能问答
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function createRobotAnswer (question, relateds, answer, categories, successcb, failedcb) {
  axios.post('/api/answer/create', {
    question,
    relateds,
    answer,
    categories
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 更新智能问答
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function updateRobotAnswer (aid, question, relateds, answer, categories, successcb, failedcb) {
  axios.post('/api/answer/update', {
    aid,
    question,
    relateds,
    answer,
    categories
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 删除智能问答
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function deleteRobotAnswer (aid, successcb, failedcb) {
  axios.post('/api/answer/delete', {
    aid
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 获取相似词
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getRobotSynonyms (page, size, successcb, failedcb) {
  axios.get('/api/synonym/get', {
    params: {
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 创建相似词
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function createRobotSynonym (standard, synonyms, successcb, failedcb) {
  axios.post('/api/synonym/create', {
    standard,
    synonyms
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 创建相似词
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function updateRobotSynonym (sid, standard, synonyms, successcb, failedcb) {
  axios.post('/api/synonym/update', {
    sid,
    standard,
    synonyms
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 创建相似词
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function deleteRobotSynonym (sid, successcb, failedcb) {
  axios.post('/api/synonym/delete', {
    sid
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 获取智能问答统计数据
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function robotStatics (successcb, failedcb) {
  axios.get('/api/robot/statics', {
    params: {
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}
